import { render } from "./customize-index.vue?vue&type=template&id=dd7273d8&scoped=true"
import script from "./customize-index.vue?vue&type=script&lang=js"
export * from "./customize-index.vue?vue&type=script&lang=js"

import "./customize-index.vue?vue&type=style&index=0&id=dd7273d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd7273d8"]])

export default __exports__